var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsers = function SvgUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#000",
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14.832 17.5v-1.667a3.333 3.333 0 0 0-3.334-3.333H4.832a3.333 3.333 0 0 0-3.334 3.333V17.5m18.334 0v-1.667a3.334 3.334 0 0 0-2.5-3.225m-3.334-10a3.333 3.333 0 0 1 0 6.459m-2.5-3.234a3.333 3.333 0 1 1-6.666 0 3.333 3.333 0 0 1 6.666 0"
  })));
};
export default SvgUsers;